export function ellipsisMiddleText(text: string) {
    const len = text.length;
    if (len < 45) return text;
    return `${text.slice(0, 21)}...${text.slice(len - 21, len)}`;
}
